import { ONE_DAY, TWO_DAYS, ONE_WEEK, ONE_MONTH } from '../../const/periodRanges';
import { HOUR, HOURS24 } from '../../const/timeRanges';

export function getHistoryGranularityMsParam(range) {
    let historyGranularityMs;
    if (range === ONE_DAY) {
        historyGranularityMs = 4 * HOUR;
    } else if (range === TWO_DAYS) {
        historyGranularityMs = 8 * HOUR;
    } else if (range === ONE_WEEK) {
        historyGranularityMs = HOURS24;
    } else if (range === ONE_MONTH) {
        historyGranularityMs = HOURS24;
    }
    return historyGranularityMs;
}